import { PLATFORMS, PRODUCTS } from '@/utilities/constants/game';
import { getPlatform } from '@/utilities/getters/gameContextGetters';
import { isIosWrapper } from '@/utilities/helpers/wrapperHelpers';
import { useStore } from '@/store/useStore';
import { ZONES } from './constants';

export const getAndroidAppVersion = (): string | undefined => {
  if (typeof navigator === 'undefined' || !navigator.userAgent)
    return undefined;
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.match(/version\/([0-9.]*)\sfanduelcasinoandroid/i)?.[1] ||
    ua.match(/version\/([0-9.]*)\sfanduelpokerandroid/i)?.[1] ||
    ua.match(/version\/([0-9.]*)\sfanduelsportsbookandroid/i)?.[1] ||
    ua.match(/version\/([0-9.]*)\sstardustcasinoandroid/i)?.[1] ||
    undefined
  );
};

export const getAndroidDistribution = ():
  | 'side-load'
  | 'play-store'
  | undefined => {
  if (typeof navigator === 'undefined' || !navigator.userAgent)
    return undefined;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('selfdist')) return 'side-load';
  if (ua.includes('playstore')) return 'play-store';
  return undefined;
};

export const launchedFrom = (): string => 'web_launcher';

/** Amplitude `Product` surface name; mirrors casino-next `getProduct()` in tracking/amplitude/utils.ts */
export type AmplitudeProductSurface =
  | 'casino_standalone_lobby'
  | 'casino_xsell_lobby'
  | 'poker_standalone_lobby';

export const getAmplitudeProduct = (): AmplitudeProductSurface | undefined => {
  const product = process.env.PRODUCT;
  switch (product) {
    case PRODUCTS.CASINO:
      return 'casino_standalone_lobby';
    case PRODUCTS.POKER:
      return 'poker_standalone_lobby';
    case PRODUCTS.XSELL:
      return 'casino_xsell_lobby';
    default:
      return undefined;
  }
};

export const getDevice = (): string => {
  const platform = getPlatform();
  if (platform === PLATFORMS.XSELL) {
    return 'x-sell';
  }
  if (platform === PLATFORMS.Android) {
    return 'Android';
  }
  if (isIosWrapper()) {
    return 'iOS';
  }
  return 'desktop';
};

export const toLoginStatus = (
  isLoggedIn: unknown,
): 'logged_in' | 'logged_out' => (isLoggedIn ? 'logged_in' : 'logged_out');

export const toNationalJurisdiction = (countryCode: unknown): string => {
  if (typeof countryCode !== 'string') return '-';
  return countryCode.toUpperCase() === 'CA' ? 'canada' : 'usa';
};

export const getExitModalZone = (): keyof typeof ZONES => {
  const gameWindowOpen = useStore.getState().gameWindowContext?.gameWindowOpen;
  return gameWindowOpen ? 'DASHBOARD' : 'IN_GAME';
};
